import React from 'react';
import PropTypes from 'prop-types';

import StepHeader from './StepHeader';
import StepFooter from './StepFooter';

import styles from './eventCreate.scss';
import { eventCreateSteps } from '../../../utils/constants';
import { isHighSchoolClub } from '../../../utils/clubs';
import { tierShape } from '../../../propTypes';

const Step = (props) => {
    const {
        currentStep,
        eventType,
        errors,
        onSubmit,
        showStepHeader,
        stepTitles,
        totalSteps,
        showPaymentSetup,
        submitting,
        editing,
        openModal,
        values,
        tiers,
    } = props;

    const showDateError = !!values?.preventDivisionDateRegistrationConflicts && values?.eventDivisions.every(division => !division?.specificDivisionDateEnabled);
    const dateErrorText = `Please add at least one division date or disable the 'Prevent same-date multiple division registrations' setting to continue.`;

    const handleToStepClick = (toStep) => {
        onSubmit(toStep);
    };

    let errorMessage = '';
    if (showDateError) {
        errorMessage = dateErrorText;
    } else {
        errorMessage = 'Please correct the invalid fields above.';
    }

    const tiersHasErrors = (tiers?.nameInputsAreTouched || submitting) && tiers?.tiers?.filter(tier => tier.shortName.trim() === '').length !== 0 && currentStep === eventCreateSteps.STEPS_4;
    const hasErrors = !!Object.keys(errors || {}).length || tiersHasErrors;
    const hasEventNameAndLocation = !isHighSchoolClub(values.tierType) ? !!(values.name && values.eventLocations[0]?.location) : true;

    return (
        <div className={`${styles.section}`}>
            <StepHeader
                currentStep={currentStep}
                totalSteps={totalSteps}
                showStepHeader={showStepHeader}
                stepTitles={stepTitles}
                editing={editing}
                openModal={openModal}
            />
            <div className={`${currentStep === eventCreateSteps.STEPS_4 ? 'd-block' : 'row'} form-block-content`}>
                {props.children}
            </div>
            {hasErrors && <div className="pb24 text-center text-error text-small"> {errors?.eventType ? `Please make an Event selection before attempting to save a draft.` : errorMessage}</div>}
            <StepFooter
                tiersHasErrors={tiersHasErrors}
                tiers={tiers}
                currentStep={currentStep}
                eventType={eventType}
                handleToStepClick={handleToStepClick}
                showPaymentSetup={showPaymentSetup}
                submitting={submitting}
                hasEventNameAndLocation={hasEventNameAndLocation}
            />
        </div>
    );
};

Step.propTypes = {
    currentStep: PropTypes.number.isRequired,
    eventType: PropTypes.number.isRequired,
    errors: PropTypes.objectOf(PropTypes.string),
    onSubmit: PropTypes.func.isRequired,
    showStepHeader: PropTypes.bool,
    stepTitles: PropTypes.objectOf(PropTypes.string).isRequired,
    tiers: PropTypes.shape({
        tiers: PropTypes.arrayOf(tierShape),
        nameInputsAreTouched: PropTypes.bool,
    }).isRequired,
    totalSteps: PropTypes.number,
    showPaymentSetup: PropTypes.bool,
    submitting: PropTypes.bool,
    editing: PropTypes.bool,
    openModal: PropTypes.bool,
    values: PropTypes.shape({
        name: PropTypes.string,
        tierType: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
        ]),
        eventLocations: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            address: PropTypes.string,
        })),
        eventDivisions: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            genderId: PropTypes.number,
            divisionFormatTypeId: PropTypes.number,
        })),
        preventDivisionDateRegistrationConflicts: PropTypes.bool,
    }),
};

Step.defaultProps = {
    errors: null,
    showPaymentSetup: false,
    showStepHeader: false,
    totalSteps: 0,
    openModal: false,
    submitting: false,
    editing: false,
    values: {},
};

export default Step;
